<script>
export default {
  name: 'JobCard',

  props: {
    job: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      deleted: false,
      CATS: {
        'DEV_FRONT_END': 'Dev Front',
        'DEV_BACK_END': 'Dev Back',
        'DESIGN': 'Design',
        'OTHER': 'Autre'
      },
      TYPES: {
        'SHORT_INTERNSHIP': 'Stage',
        'LONG_INTERNSHIP': 'Alternance'
      }
    }
  },

  computed: {
    tags() {
      return this.job.tags && this.job.tags.split(',')
    }
  },

  methods: {
    deleteJob() {
      if (!confirm('SURE ?')) {
        return
      }

      this.axios.delete('/jobs/' + this.job.id)
        .then(() => {
          this.$alert({
            type: 'success',
            trans: 'messages.job_deleted'
          })
          this.deleted = true
        })
    }
  }
}
</script>

<template>
  <div class="card" v-if="!deleted">
    <div class="card-content">
      <div class="columns">
        <div
          class="column is-narrow"
          v-if="job.logo">
          <figure class="image is-48x48">
            <img :src="job.logo" :alt="job.company">
          </figure>
        </div>
        <div class="column">
          <p class="is-size-4">{{ job.title }}</p>
          <p class="is-size-6">
            <span>@{{ job.company }}</span> - <span>{{ job.whatwedo }}</span>
          </p>
          <p class="is-size-7">{{ job.city + ', ' + job.country }}</p>
        </div>
        <div class="column is-narrow">
          <p class="title is-6">{{ TYPES[job.type.name] }}</p>
          <p class="subtitle is-6">{{ CATS[job.category.name] }}</p>
          <p class="is-size-7">{{ job.created_at | moment("from") }}</p>
        </div>
      </div>

      <div class="tags">
        <span
          class="tag"
          v-for="(tag, i) in tags"
          :key="tag+i">
          {{ tag }}
        </span>
      </div>
    </div>

    <footer class="card-footer">
      <router-link
        class="card-footer-item"
        :to="{name: 'job_edit', params: {id: job.id}}">
        Modifier
      </router-link>
      <a class="card-footer-item"
        @click="deleteJob">
        Supprimer
      </a>
    </footer>
  </div>
</template>

<style scoped>
.media-content {
  overflow: initial;
}

.description {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/JobCard.vue